import CloseIcon from '@material-ui/icons/Close';
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    useTheme
} from "@mui/material";
import { useState } from "react";
// import imagePlaceholder from '../../assets/img/image_placeholder.jpg';
import StuonB1 from '../../assets/img/StudentOnBoarding/StuonB1.png';
import StuonB2 from '../../assets/img/StudentOnBoarding/StuonB2.png';
import StuonB3 from '../../assets/img/StudentOnBoarding/StuonB3.png';
// import StuonB4 from '../../assets/img/StudentOnBoarding/StuonB4.png';
import StuonB5 from '../../assets/img/StudentOnBoarding/StuonB5.png';





const steps = [
    {
        title: "1.	Navigate to the Dashboard and click on the Students tab.",
        description: [
            // "From the Dashboard, click on the Students tab.",
            // "OR go to Manage Users and select the Students option.",
            // "Select the Test to assign, In the Actions Column, Click the Assign button.",

        ],
        image: StuonB1,
    },
    {

        title: "2.	Go to Manage Users and select the Students option. ",
        description: [
            // "Select students from the Available list section, Click the ‘Assign Student’ button That’s it! The test is now assigned to students!",
        ],
        image: StuonB2,
    },

    // 
    {
        mainTitle: "Add/onboard an individual student",
        // title: "On the Student page, click the ‘+ Add’ button, enter the student details, and click Save. That’s it!",
        description: [
            "On the Student page, click the ‘+ Add’ button, enter the student details, and click Save. That’s it!"
        ],
        image: StuonB3,
    },
    // {
    //     title: "Schedule Immediately",
    //     description: [
    //         "Select the Now option to start the test immediately.",
    //     ],
    //     image: StuonB4,
    // },
    {
        mainTitle: "Bulk Student Onboarding",
        // title: "Onboard all students at once in bulk. First, complete the Student Onboarding Excel Template. Then, go to the student page, click the 'Import' button, select your Excel file, and import. That's it!",
        description: [
            "Onboard all students at once in bulk. First, complete the Student Onboarding Excel Template. Then, go to the student page, click the 'Import' button, select your Excel file, and import. That's it!",
        ],
        image: StuonB5,
    },
];

function StudentsOnBoardingSteps() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (imgSrc) => {
        setSelectedImage(imgSrc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };
    return (
        <Box maxWidth="md" mx="auto" p={4}>
            <Typography variant="h5" gutterBottom>
                Onboarding Students <br />
                <small>There are two ways to do this:</small>
            </Typography>

            {steps.map((step, index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
                    alignItems="center"
                    my={5}
                    gap={4}
                    flexWrap="wrap"
                >
                    <Box
                        component="img"
                        src={step?.image}
                        alt={`Step ${index + 1}`}
                        onClick={() => handleImageClick(step.image)}
                        sx={{
                            width: { xs: "100%", sm: "25%" },
                            borderRadius: 2,
                            boxShadow: 3,
                            visibility: step.image ? 'visible' : 'hidden',
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.05)",
                            },
                        }}
                    />
                    <Box flex="1" minWidth="250px">
                        {step?.mainTitle && <Typography variant="h6" sx={{ color: '#e63573', textTransform: 'none' }}>{step.mainTitle}</Typography>}
                        <Typography variant="body1" sx={{ textTransform: 'none', fontWeight: 'bold' }}>{step.title}</Typography>
                        <ul>
                            {step.description.map((item, idx) => (
                                <li key={idx}>
                                    <Typography variant="body1">{item}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Box>
                </Box>
            ))}
            {/* Dialog for Image Popup */}
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: "grey.500",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {selectedImage && (
                        <Box
                            component="img"
                            src={selectedImage}
                            alt="Popup Preview"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: 2,
                                boxShadow: 3,
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default StudentsOnBoardingSteps;
